// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"4f5b344f","598":"b0e79915","703":"cdd6fcaa","787":"54066137"}[chunkId] + ".chunk.js";
};